export const categories = [
  { name: 'Funerals', value: 'CASES' },
  { name: 'Accounts', value: 'ACCOUNTS' },
  { name: 'Auditing', value: 'AUDITING' },
  { name: 'Trends', value: 'TRENDS' },
  { name: 'Performance', value: 'PERFORMANCE' },
];
